import { helpers } from '@linqpal/common-frontend'
import React, { useMemo } from 'react'
import { Linking, StyleSheet, TextStyle, ViewStyle } from 'react-native'
import { Text } from 'react-native-paper'
import { isWeb } from '../../utils/helpers/commonUtils'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { Trans, useTranslation } from 'react-i18next'
import { urls } from '@linqpal/models/src/dictionaries'
import LegalFiles from '../../utils/helpers/legalFiles'

const { composeStyle } = helpers

const styles = StyleSheet.create({
  label: {
    lineHeight: 20,
    marginVertical: 16,
    paddingBottom: 8,
  },
})

const openUrl = (url) => {
  if (isWeb) {
    window.open(url, '_blank')
  } else {
    Linking.openURL(url)
  }
}

type Props = {
  style?: ViewStyle | TextStyle
  testID?: string
}

export default function TermsAndConditions({ style, testID }: Props) {
  const { t } = useTranslation('auth')
  const { textLight, accentText } = commonColors
  const labelStyle = useMemo(
    () => composeStyle(styles.label, style, { color: textLight }),
    [textLight, style],
  )
  const linkLabelStyle = useMemo(
    () => composeStyle(styles.label, style, { color: accentText }),
    [accentText, style],
  )
  return (
    <Text style={labelStyle} testID={testID}>
      <Trans t={t} i18nKey={'terms'}>
        By continuing, you agree to our{' '}
        <Text style={linkLabelStyle} onPress={() => openUrl(urls.TC)}>
          Terms & Conditions
        </Text>
        , and{' '}
        <Text style={linkLabelStyle} onPress={() => openUrl(urls.PP)}>
          Privacy Policy
        </Text>
      </Trans>
    </Text>
  )
}

export function PayTermsAndConditions() {
  const { t } = useTranslation('global')
  const { textLight, accentText } = commonColors

  const labelStyle = useMemo(
    () =>
      composeStyle(styles.label, {
        color: textLight,
        fontSize: 12,
        fontWeight: '500',
      }),
    [textLight],
  )
  const linkLabelStyle = useMemo(
    () =>
      composeStyle(styles.label, {
        color: accentText,
        fontSize: 12,
        fontWeight: '500',
      }),
    [accentText],
  )

  return (
    <Text style={labelStyle}>
      <Trans t={t} i18nKey={'payTerms&Cond'}>
        By continuing, you agree to the{' '}
        <Text style={linkLabelStyle} onPress={LegalFiles.customerAgreement}>
          Customer Agreement
        </Text>
        ,{' '}
        <Text style={linkLabelStyle} onPress={() => openUrl(urls.TC)}>
          Terms & Conditions
        </Text>
        , and{' '}
        <Text style={linkLabelStyle} onPress={() => openUrl(urls.PP)}>
          Privacy Policy
        </Text>
      </Trans>
    </Text>
  )
}
